import CoreAPI from "./coreAPI";

export default function APIAdmin(coreAPI: CoreAPI) {
  return {
    async verifyEmail(email: string) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/verifyEmail",
        body: {
          email,
        },
      });
    },
    async loginAsAdmin(username: string, password: string) {
      return coreAPI.call<{
        accessToken: string;
      }>({
        method: "POST",
        endpoint: "/auth/loginAdmin",
        body: {
          username,
          password,
        },
      });
    },
  };
}
